var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 268,
    height: 260,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 22,
    y: 109,
    width: 76,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 96,
    y: 109,
    width: 76,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 170,
    y: 109,
    width: 76,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 22,
    y: 211,
    width: 76,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 96,
    y: 211,
    width: 76,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 170,
    y: 211,
    width: 76,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h63v4H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h222v180H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h222v73H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1347"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 46",
    transform: "translate(-282 -1236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(282 1236)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h228a8 8 0 0 1 8 8v228H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h228a7.5 7.5 0 0 1 7.5 7.5v227.5h-243V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302 1250h228a8 8 0 0 1 8 8v16H294v-16a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 1250.5h228a7.5 7.5 0 0 1 7.5 7.5v15.5h-243V1258a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(304 1259)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16)",
    fill: "#00c243"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294 1273h244v20H294z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M294.5 1273.5h243v19h-243z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(304 1278)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 1",
    transform: "translate(464 1281)",
    opacity: 0.5,
    clipPath: "url(#b)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(16)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(32)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(48)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 23",
    transform: "translate(22 70)",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1344",
    transform: "translate(-189 -2997)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 22",
    transform: "translate(189 3012)",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1343",
    transform: "translate(-189 -2993)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(167 2908)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    d: "M28 113h64v34a3 3 0 0 1-3 3H31a3 3 0 0 1-3-3v-34Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3030)",
    fill: "#9098a4",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3038)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1572",
    width: 34,
    height: 4,
    rx: 1,
    transform: "translate(206 3045)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1571",
    d: "M198 2993h58a3 3 0 0 1 3 3v25h-64v-25a3 3 0 0 1 3-3Z",
    fill: "#9098a4"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1343",
    transform: "translate(-115 -2993)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 2908)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    d: "M102 113h64v34a3 3 0 0 1-3 3h-58a3 3 0 0 1-3-3v-34Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3030)",
    fill: "#9098a4",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3038)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1572",
    width: 34,
    height: 4,
    rx: 1,
    transform: "translate(206 3045)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1571",
    d: "M198 2993h58a3 3 0 0 1 3 3v25h-64v-25a3 3 0 0 1 3-3Z",
    fill: "#9098a4"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1343",
    transform: "translate(-41 -2993)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 2908)",
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    d: "M176 113h64v34a3 3 0 0 1-3 3h-58a3 3 0 0 1-3-3v-34Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3030)",
    fill: "#9098a4",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3038)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1572",
    width: 34,
    height: 4,
    rx: 1,
    transform: "translate(206 3045)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1571",
    d: "M198 2993h58a3 3 0 0 1 3 3v25h-64v-25a3 3 0 0 1 3-3Z",
    fill: "#9098a4"
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1573",
    width: 82,
    height: 6,
    rx: 1,
    transform: "translate(195 2997)",
    fill: "#9098a4",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1344",
    transform: "translate(-189 -2895)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 22",
    transform: "translate(189 3012)",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1343",
    transform: "translate(-189 -2993)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(167 2806)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    d: "M28 215h64v34a3 3 0 0 1-3 3H31a3 3 0 0 1-3-3v-34Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3030)",
    fill: "#9098a4",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3038)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1572",
    width: 34,
    height: 4,
    rx: 1,
    transform: "translate(206 3045)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1571",
    d: "M198 2993h58a3 3 0 0 1 3 3v25h-64v-25a3 3 0 0 1 3-3Z",
    fill: "#9098a4"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1343",
    transform: "translate(-115 -2993)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 2806)",
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    d: "M102 215h64v34a3 3 0 0 1-3 3h-58a3 3 0 0 1-3-3v-34Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3030)",
    fill: "#9098a4",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3038)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1572",
    width: 34,
    height: 4,
    rx: 1,
    transform: "translate(206 3045)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1571",
    d: "M198 2993h58a3 3 0 0 1 3 3v25h-64v-25a3 3 0 0 1 3-3Z",
    fill: "#9098a4"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1343",
    transform: "translate(-41 -2993)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 2806)",
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    d: "M176 215h64v34a3 3 0 0 1-3 3h-58a3 3 0 0 1-3-3v-34Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3030)",
    fill: "#9098a4",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(206 3038)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1572",
    width: 34,
    height: 4,
    rx: 1,
    transform: "translate(206 3045)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1571",
    d: "M198 2993h58a3 3 0 0 1 3 3v25h-64v-25a3 3 0 0 1 3-3Z",
    fill: "#9098a4"
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1573",
    width: 82,
    height: 6,
    rx: 1,
    transform: "translate(195 2997)",
    fill: "#9098a4",
    opacity: 0.8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketNews);
export default __webpack_public_path__ + "static/media/market-news.964e85e7da94bfd575547f05332924b3.svg";
export { ForwardRef as ReactComponent };